import { useJobItemDetails } from '../../api/use-job-item-details';
import { useSetupLanguage } from '../../hooks/use-language';
import type { CommentLanguageOption } from './types';

type UseSidepanelCommentLanguagesParams = {
    readonly architectureId: string;
    readonly itemId: string;
    readonly itemType: 'job-level' | 'job-role';
    readonly version: number;
};

export const useSidepanelCommentLanguages = ({
    architectureId,
    itemId,
    itemType,
    version,
}: UseSidepanelCommentLanguagesParams): readonly CommentLanguageOption[] => {
    const { data: item } = useJobItemDetails({
        architectureId,
        itemId,
        itemType,
        version: version.toString(),
    });

    const { availableLanguages } = useSetupLanguage(undefined, item?.jobProfile);

    return availableLanguages;
};
